var _excluded = ["height", "width"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

var IconIllustrativeInfo = function IconIllustrativeInfo(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8 8.2C50.023 2.301 41.012.06 32 0 22.989.061 13.978 2.303 8.2 8.2 2.302 13.977.06 22.988 0 32c.061 9.011 2.303 18.023 8.2 23.8 5.777 5.898 14.789 8.14 23.8 8.2 9.011-.061 18.022-2.302 23.8-8.2C61.699 50.023 63.94 41.012 64 32c-.061-9.011-2.302-18.023-8.2-23.8",
    fill: "#007FF1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.742 48h4.516V32h-4.516v16zM34.105 17.973a3.264 3.264 0 00-.957-.6 2.988 2.988 0 00-1.149-.224c-.827 0-1.537.284-2.123.866-.59.576-.885 1.264-.885 2.068 0 .8.3 1.476.9 2.028a3.02 3.02 0 002.109.828c.828 0 1.535-.29 2.126-.864.59-.576.882-1.266.882-2.07 0-.4-.083-.774-.247-1.126a2.842 2.842 0 00-.656-.906",
    fill: "#fff"
  }));
};

IconIllustrativeInfo.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
export default IconIllustrativeInfo;
//# sourceMappingURL=IconIllustrativeInfo.js.map